import {Fragment} from 'react';
import {useForm} from 'react-hook-form';
import {Trans} from '@ui/i18n/trans';
import {Form} from '@ui/forms/form';
import {FormTextField} from '@ui/forms/input-field/text-field/text-field';
import {Button} from '@ui/buttons/button';
import {StaticPageTitle} from '@common/seo/static-page-title';
import {useRecaptcha} from '@common/recaptcha/use-recaptcha';
import {
  ContactPagePayload,
  useSubmitContactForm,
} from '@common/contact/use-submit-contact-form';
import {SitePageLayout} from '@app/site-page-layout';

/**
 * CUSTOM(albaniantheatre): fork of @common/contact/contact-us-page with the
 * foundation Navbar/Footer wrapper swapped for SitePageLayout, so the site
 * header does not change when "Contact Us" is clicked in the footer. The form
 * itself is unchanged — re-diff against the foundation page after an MTDb
 * update.
 */
export function SiteContactUsPage() {
  const form = useForm<ContactPagePayload>();
  const submitForm = useSubmitContactForm(form);
  const {verify, isVerifying} = useRecaptcha('contact');

  return (
    <Fragment>
      <StaticPageTitle>
        <Trans message="Contact us" />
      </StaticPageTitle>
      <SitePageLayout>
        <div className="container mx-auto flex items-center justify-center p-24 md:p-40">
          <div className="w-full max-w-620 rounded border bg-paper p-24">
            <h1 className="text-2xl">
              <Trans message="Contact us" />
            </h1>
            <p className="mb-30 mt-4 text-sm">
              <Trans message="Please use the form below to send us a message and we'll get back to you as soon as possible." />
            </p>
            <Form
              form={form}
              onSubmit={async value => {
                const isValid = await verify();
                if (isValid) {
                  submitForm.mutate(value);
                }
              }}
            >
              <FormTextField
                label={<Trans message="Name" />}
                name="name"
                required
                className="mb-20"
              />
              <FormTextField
                label={<Trans message="Email" />}
                name="email"
                required
                type="email"
                className="mb-20"
              />
              <FormTextField
                label={<Trans message="Message" />}
                name="message"
                required
                inputElementType="textarea"
                className="mb-20"
                rows={8}
              />
              <Button
                type="submit"
                variant="flat"
                color="primary"
                disabled={submitForm.isPending || isVerifying}
              >
                <Trans message="Send" />
              </Button>
            </Form>
          </div>
        </div>
      </SitePageLayout>
    </Fragment>
  );
}
